export const getAutosetapp = (state) =>
  state.autosetapp;



// WEBPACK FOOTER //
// ./src/store/selectors/autosetapp.js